module.exports = __webpack_public_path__ + "img/UI_common_framelabelBD_01_c9183f9bc.png";